import { ResponsiveDialog } from '@cibo/ui'
import { Alert, Button, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useProgramEngagementUnconfirmTasks } from '../../../../queries'

type ConfirmRollbackDialogProps = {
  open: boolean
  onClose(): void
  rollbackTaskIds?: string[]
  onSuccess?: () => void
  engagementId?: string
}

export const ConfirmRollbackDialog = ({
  open,
  onClose,
  onSuccess,
  rollbackTaskIds,
  engagementId,
}: ConfirmRollbackDialogProps) => {
  const { t } = useTranslation('@cibo/programs/ProgramEngagementPlayer/ConfirmRolbackDialog')
  const unconfirmTasks = useProgramEngagementUnconfirmTasks()
  const { enqueueSnackbar } = useSnackbar()

  const handleContinue = () => {
    if (!engagementId || !rollbackTaskIds) return

    unconfirmTasks
      .mutateAsync({ id: engagementId, taskIds: rollbackTaskIds })
      .then(() => {
        onSuccess && onSuccess()
        onClose()
      })
      .catch(error => {
        enqueueSnackbar(t(`error`), {
          variant: 'error',
        })
      })
  }

  return (
    <ResponsiveDialog data-testid="confirm-rollback-dialog" {...{ open, onClose }}>
      <DialogTitle>{t('areYouSure')}</DialogTitle>
      <DialogContent>
        <Alert severity="warning">{t('alert')}</Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('no')}</Button>
        <Button
          variant="contained"
          color="warning"
          onClick={handleContinue}
          loading={unconfirmTasks.isPending}
          data-testid="continueBtn"
        >
          {t('continue')}
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}
